import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  TextField,
  Button
} from '@material-ui/core';
import { Sms as SmsIcon } from '@material-ui/icons';
import { useState } from 'react';
import { toast } from 'sonner';
import { useMembersContext } from '../../context/onoff_context';
import { fullName } from './StatusPill';

export function SmsDialog({ open, onClose, recipients }) {
  const [body, setBody] = useState('');
  const { sendSms } = useMembersContext();
  const [sending, setSending] = useState(false);
  const reachable = recipients.filter((m) => (m.phone ?? '').trim().length >= 7);
  const missing = recipients.length - reachable.length;

  const send = async () => {
    setSending(true);
    try {
      const result = await sendSms(recipients, body.trim());
      if (result.sent > 0) toast.success(`${result.sent} notice(s) sent.`);
      if (result.failed > 0) toast.error(`${result.failed} notice(s) could not be sent.`);
      if (result.skipped > 0)
        toast.warning(`${result.skipped} member(s) skipped — no phone number on record.`);
      if (result.sent > 0) {
        setBody('');
        onClose();
      }
    } catch {
      toast.error('The SMS service could not be reached.');
    } finally {
      setSending(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <SmsIcon color="secondary" /> Send SMS notice
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          {recipients.length === 1
            ? `To ${fullName(recipients[0])} (${recipients[0].emp_no}).`
            : `To ${recipients.length} selected member(s).`}
          {missing > 0 ? ` ${missing} have no phone number and will be skipped.` : ''}
        </DialogContentText>
        <TextField
          label="Message"
          multiline
          rows={5}
          fullWidth
          inputProps={{ maxLength: 480 }}
          placeholder="Dear member, your pay status requires attention. Please contact the office."
          value={body}
          onChange={(e) => setBody(e.target.value)}
          helperText={`${body.length}/480 characters`}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={sending}>
          Cancel
        </Button>
        <Button
          variant="contained"
          disabled={body.trim().length === 0 || reachable.length === 0 || sending}
          onClick={send}
        >
          {sending ? 'Sending…' : `Send to ${reachable.length} member(s)`}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
